export const AUTH_CONSTANTS = {
  APP_YEAR: new Date().getFullYear(),
  APP_NAME: 'PowerReady',
  APP_DESCRIPTION: 'PowerReady Public Safety Software',
  APP_COPYRIGHT: 'All rights reserved.',
  AUTH_PREFIX: 'Bearer',
  CLIENT_ID: 'a360-client-id',
  TOKEN_LS_KEY: 'a360-refresh-token',
  TOKEN_SS_KEY: 'a360-access-token',
  TIME_DIFF_KEY: 'a360-fe-be-time-diff',
  TOASTER_FOR_IE_SHOWN: 'toaster-for-ie-shown'
};
